<app-mat-spinner-overlay *ngIf="showSpinner"></app-mat-spinner-overlay>

<div class="dialog-container">
  <div class="dialog-header">
    <h5 class="dialog-title">File Checking</h5>
    <button class="close-btn" (click)="closeDialog()">&times;</button>
  </div>

  <div class="dialog-body">
    <form #f="ngForm" (ngSubmit)="onSaveCustomerFileChecking()" novalidate>
      <div class="question-header row m-0">
        <div class="col-md-1 pl-1"><b>#</b></div>
        <div class="col-md-4 pl-1"><b>Checking Points</b></div>
        <div class="col-md-2 pl-1"><b>Select</b></div>
        <div class="col-md-3 pl-1"><b>Remark</b></div>
        <div class="col-md-2 pl-1"><b>Action</b></div>
      </div>

      <div class="question-list">
        <div class="row m-0 mt-2" *ngFor="let question of questionData; let i = index">
          <div class="col-md-1">{{ i + 1 }}</div>
          <div class="col-md-4">{{ question.FileCheckingName }}</div>
          <div class="col-md-2 pl-1">
            <select name="QS{{ i }}" id="QS{{ i }}" #refQS="ngModel"
                    class="form-control input-text-css" required [(ngModel)]="question.SelectOption" [disabled]="IsDisabled"
                    [ngClass]="{'is-invalid': f.submitted && refQS.invalid, 'alert-warning': refQS.invalid && (refQS.dirty || refQS.touched || refQS.untouched)}">
              <option value="" [selected]="question.SelectOption === ''">Select</option>
              <ng-container *ngFor="let option of question.FileCheckingDropdown">
                <option [value]="option">{{ option }}</option>
              </ng-container>
            </select>
          </div>
          <div class="col-md-3 pl-1">
            <textarea rows="1" name="QTRemark{{ i }}" id="QTRemark{{ i }}"
                      [disabled]="IsDisabled" class="form-control input-text-css"
                      [(ngModel)]="question.Remark" placeholder="Remark"></textarea>
          </div>
          <div class="col-md-2 pl-1">
            <select name="Action{{ i }}" id="Action{{ i }}" #refAction="ngModel"
                    class="form-control input-text-css" [(ngModel)]="question.Action_Status" [disabled]="IsDisabled">
              <option value="" [selected]="!question.Action_Status || question.Action_Status === ''">Select</option>
              <option *ngFor="let opt of actionOptions" [value]="opt">{{ opt }}</option>
            </select>
          </div>
        </div>
      </div>

      <div class="dialog-footer">
        <button type="button" (click)="onEditFileChecking()" *ngIf="IsEdit"
                class="btn font-size-12 button-btn">
          Edit
        </button>
        <button type="submit" *ngIf="IsSave" class="btn font-size-12 button-btn"
                [class.spinner]="loading" [disabled]="!f.form.valid">
          Save
        </button>
        <button type="submit" *ngIf="IsUpdate" class="btn font-size-12 button-btn"
                [class.spinner]="loading" [disabled]="!f.form.valid">
          Update
        </button>
        <button type="button" (click)="closeDialog()" class="btn font-size-12 button-btn-cancel ml-2">
          Close
        </button>
      </div>
    </form>
  </div>
</div>
